

var feeJS = feeJS || {};
feeJS.extendArtistList = (e) => {
  const list = document.querySelector('.js-artistList');
  if (!list) return;
  list.classList.add('is-extended');
}
